import React, {Component} from 'react'
import stylesNormal from './modal.module.scss';
import stylesFullScreen from './modalFull.module.scss';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true
    }
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.modalClose);
  }

  componentDidMount(){
    document.body.addEventListener('click', this.modalClose);
  }

  modalClose = () => {
    if(this.props.close){
      this.props.close();
    }
  };

  render(){

   const styles =  this.props.fullScreen ? stylesFullScreen : stylesNormal;


    if(this.state && this.state.open) {
      return (
        <div className={styles.modalContainer}>
          <div className={styles.centerBlock}>
            <button className={styles.modalCloseIcon} onClick={() => this.modalClose}>X</button>
            {this.props.children}
          </div>
        </div>

      )
    }
    return null;

  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal/modal.js